/** Certifications, regulatory framework explainers and the document library. */

export const certifications = [
  {
    id: 'cpcb',
    code: 'CPCB',
    title: 'CPCB Authorised Recycler',
    issuer: 'Central Pollution Control Board',
    // validTill: 'Mar 2029',
    description:
      'Authorised sellers that can collect, dismantle and recycle e-waste under the E-Waste (Management) Rules, 2022 and to issue statutory documentation.',
  },
  {
    id: 'iso-9001',
    code: 'ISO 9001',
    title: 'Quality Management System',
    issuer: 'ISO 9001:2015',
    // validTill: 'Aug 2027',
    description:
      'Documented processes for intake, processing and certificate issuance, audited annually by an accredited body.',
  },
  {
    id: 'iso-14001',
    code: 'ISO 14001',
    title: 'Environmental Management',
    issuer: 'ISO 14001:2015',
    // validTill: 'Aug 2027',
    description:
      'Controls covering emissions, effluent, hazardous fractions and landfill diversion across the facility.',
  },
  {
    id: 'iso-45001',
    code: 'ISO 45001',
    title: 'Occupational Health & Safety',
    issuer: 'ISO 45001:2018',
    // validTill: 'Aug 2027',
    description:
      'Worker safety systems covering PPE, hazardous handling, incident reporting and periodic health checks.',
  },
  {
    id: 'r2v3',
    code: 'R2v3',
    title: 'Responsible Recycling',
    issuer: 'SERI R2v3',
    // validTill: 'Jan 2028',
    description:
      'International standard for responsible reuse and recycling, including data security and downstream due diligence.',
  },
//   {
//     id: 'mpcb',
//     code: 'MPCB',
//     title: 'State Consent to Operate',
//     issuer: 'Maharashtra Pollution Control Board',
//     validTill: 'Dec 2028',
//     description:
//       'Consent to establish and operate the Taloja facility at the authorised annual processing capacity.',
//   },
 ];

/** Regulatory framework explainers rendered as cards on the Compliance page. */
export const regulations = [
  {
    id: 'ewaste-rules',
    title: 'E-Waste (Management) Rules, 2022',
    summary:
      'The governing framework for e-waste in India. Producers, bulk consumers and recyclers each carry defined obligations for collection, channelisation and record keeping.',
    points: [
      'Bulk consumers must channelise e-waste only to authorised recyclers',
      'Records must be maintained in Form 6 and produced on inspection',
      'Annual returns are due by 30 June for the preceding financial year',
    ],
  },
  {
    id: 'epr',
    title: 'Extended Producer Responsibility',
    summary:
      'Producers carry a recycling target proportional to what they place on the market. Targets are met through EPR credits generated by authorised recyclers.',
    points: [
      'Targets are calculated on historical sales and product category',
      'Credits are generated only by CPCB-registered recyclers',
      'Shortfalls attract environmental compensation under the rules',
    ],
  },
  {
    id: 'data-rules',
    title: 'Data Protection Obligations',
    summary:
      'Disposing of storage media without verified sanitisation leaves personal data exposed. Certified destruction closes that gap with an auditable record.',
    points: [
      'NIST 800-88 Purge and Destroy methods applied by media type',
      'Serial-wise certificates map every drive to its disposal method',
      'Witnessed or video-recorded destruction available on request',
    ],
  },
  {
    id: 'battery-rules',
    title: 'Battery Waste Management Rules, 2022',
    summary:
      'Separate obligations apply to lithium-ion, lead-acid and industrial battery banks, including safe transport and recovery reporting.',
    points: [
      'Thermal-safe packaging mandated for lithium chemistries',
      'Recovery percentages must be reported by chemistry',
      'Producer obligations tracked separately from e-waste targets',
    ],
  },
];

/**
 * Sample documents shown in the compliance library. Files are illustrative —
 * clicking opens an in-app preview modal rather than a download.
 */
export const documentLibrary = [
  {
    id: 'doc-form6',
    name: 'Form 6 — Specimen',
    type: 'Statutory Record',
    updated: '2026-04-12',
    description:
      'Specimen of the Form 6 record issued for every consignment, showing quantities by category and the recycler authorisation reference.',
  },
  {
    id: 'doc-cert',
    name: 'Recycling Certificate — Specimen',
    type: 'Certificate',
    updated: '2026-04-12',
    description:
      'Stream-wise certificate confirming environmentally sound processing, with consignment reference and processed weight.',
  },
  {
    id: 'doc-dds',
    name: 'Data Destruction Certificate — Specimen',
    type: 'Certificate',
    updated: '2026-03-02',
    description:
      'Serial-wise record of media sanitised or shredded, the NIST 800-88 method applied and the operator who performed it.',
  },
  {
    id: 'doc-authorisation',
    name: 'CPCB Authorisation Letter',
    type: 'Licence',
    updated: '2026-01-20',
    description:
      'The CPCB authorisation letter for the recycler, showing the authorised categories, annual capacity and validity period.',
  },
  {
    id: 'doc-iso',
    name: 'ISO Certificate Pack',
    type: 'Certificate',
    updated: '2025-08-18',
    description:
      'Consolidated ISO 9001, 14001 and 45001 certificates with scope statements and validity dates.',
  },
  {
    id: 'doc-sop',
    name: 'Chain-of-Custody SOP',
    type: 'Policy',
    updated: '2025-11-05',
    description:
      'The standard operating procedure governing sealing, transport, intake reconciliation and record retention.',
  },
];
